import { RelatedEntityType } from "../common/common.types";

// Base communication interface
export interface Communication {
	id: number;
	subject: string;
	from: string;
	to: string[];
	date: string;
	isProcessed: boolean;
	htmlContent: string;
	status: string;
	direction?: "INBOUND" | "OUTBOUND";
	attachments?: Array<{
		id: number;
		fileName: string;
		contentType: string;
		size: number;
		url: string;
	}>;
}

// Add broker-specific fields here if needed
export interface BrokerCommunication extends Communication {
	relatedEntities?: Array<{
		entityType: RelatedEntityType;
		entityId: number;
		entityReference: string | number | null;
		status?: string | null;
	}>;
}

export interface PropositionCommunication extends Communication {
	// Add proposition-specific fields here if needed
}

export interface CommunicationListItem {
	id: number;
	subject: string;
	from: {
		name: string;
		email: string;
		initials: string;
	};
	to: {
		name: string;
		email: string;
		initials: string;
	};
	date: string;
	direction: "INBOUND" | "OUTBOUND";
	status: "SENT" | "RECEIVED" | "DRAFT" | "FAILED";
	htmlContent?: string;
	attachments?: Array<{
		fileName: string;
		contentType: string;
		size: number;
		url: string;
	}>;
}

export const CommunicationStatus = {
	READ: "Lu",
	UNREAD: "Non lu",
	ALL: "Toutes",
} as const;

export type CommunicationStatusValues = typeof CommunicationStatus[keyof typeof CommunicationStatus];

export const COMMUNICATION_FILTER = {
	UNREAD: "unread",
	READ: "read",
	DRAFT: "draft",
	SENT: "sent",
	RECEIVED: "received",
	ARCHIVED: "archived",
} as const;

export type CommunicationFilterValue =
	(typeof COMMUNICATION_FILTER)[keyof typeof COMMUNICATION_FILTER];

export const COMMUNICATION_FILTER_LABELS: Record<
	CommunicationFilterValue,
	string
> = {
	unread: "Non lu",
	read: "Lu",
	draft: "Brouillons",
	sent: "Envoyés",
	received: "Reçus",
	archived: "Archivés",
};
